export default __webpack_public_path__ + "static/media/robot_datos-01.c64aa89b.jpg";